export { default } from './MedMapDeckOverlay';
